import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { ChangeDetectorRef, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';

import Swal from 'sweetalert2';




@Component({
  selector: 'app-invoice-module',
  templateUrl: './invoice-module.component.html',
  styleUrls: ['./invoice-module.component.css']
})
export class InvoiceModuleComponent implements OnInit {
  @Input() finalinvoiceres: any=[];
  @Input() invoiceLink: any;
  @Input() actionButtons: {
    condition: any;
    backgroundColor: string;
    icon: string;
    label: string;
    onClick: () => void;
  }[] = [];
    @Input() showModal: boolean = false;

  constructor(
    private http: HttpClient,
  ) { }

  ngOnInit(): void {
  }



  getInvoiceDetails: any = '';


  InvoiceStatus: any[] = [];

   close() {
    this.showModal = false;
  }

  // getInvoiceStatus(value: any) {

  //   if (value) {
  //     let status = this.InvoiceStatus.filter(payment => payment.value == value)
  //     return status[0].name
  //   }

  // }
  getInvoiceStatus(value: any): string {
  if (!value || !this.InvoiceStatus?.length) return 'N/A';

  const status = this.InvoiceStatus.find(payment => payment.value === value);
  return status?.name || 'N/A';
}

    DownloadInvoice(invoice: any) {
      this.http.get(invoice, { responseType: "arraybuffer" }).subscribe(
        pdf => {
          const blob = new Blob([pdf], { type: "application/pdf" });
          const fileName = `${this.getInvoiceDetails.invoiceNumber}` + ".pdf";
          saveAs(blob, fileName);
        },
        (error) => {
          Swal.fire({ allowOutsideClick: false, title: "Error", text: error.error.error.message })
        }
      );
  
    }

}
